// DesktopOnlyGuard — заглушка, которая показывает на мобильных устройствах
// сообщение «доступно только на компьютере» вместо тяжёлого контента.
//
// Используется для редактора схем и 3D-CAD: мышь+клавиатура необходимы,
// touch-управление не поддерживается, узкий экран не вмещает панели.

import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import cl from './DesktopOnlyGuard.module.css';

const MOBILE_BREAKPOINT = 1024;


const DesktopOnlyGuard = ({ children, title, description, icon = '💻' }) => {
    // SSR-safe: на сервере window нет, рендерим children сразу — клиент потом
    // переопределит после mount.
    const [isMobile, setIsMobile] = useState(() => {
        if (typeof window === 'undefined') return false;
        return window.innerWidth < MOBILE_BREAKPOINT;
    });

    useEffect(() => {
        const onResize = () => setIsMobile(window.innerWidth < MOBILE_BREAKPOINT);
        window.addEventListener('resize', onResize);
        // На случай поворота телефона
        window.addEventListener('orientationchange', onResize);
        return () => {
            window.removeEventListener('resize', onResize);
            window.removeEventListener('orientationchange', onResize);
        };
    }, []);

    if (!isMobile) return children;

    return (
        <div className={cl.wrap}>
            <div className={cl.card}>
                <div className={cl.icon}>{icon}</div>
                <h2 className={cl.title}>{title || 'Доступно только на компьютере'}</h2>
                <p className={cl.text}>
                    {description || 'Этот раздел требует мыши, клавиатуры и большого экрана.\nОткройте сайт на компьютере или ноутбуке, чтобы продолжить.'}
                </p>
                <div className={cl.hint}>
                    <span className={cl.hintIcon}>📱</span>
                    Если вы и так за компьютером — попробуйте раскрыть окно браузера шире.
                </div>
                <Link to="/main" className={cl.btn}>← Назад к разделам</Link>
            </div>
        </div>
    );
};

export default DesktopOnlyGuard;
